<template>
  <div class="w-full h-screen bg-gray-100">
    <div class="flex flex-col justify-between h-full">
      <Header></Header>
      <div class="conteudo">
        <div>
          <Alerta :mensagem-erro="mensagemDeErro" :mostra-alerta="mostrarAlerta" @closeAlert="fecharAlerta"></Alerta>
          <div class="h-full bg-gray-100">
            <div class="flex flex-row justify-around">
              <div class="my-4 flex flex-row flex-wrap">
                <span class="w-full text-center modules text-3xl font-medium roboto uppercase text-gray-900">{{
                  projectName
                  }}</span>
                <span class="w-full text-xl roboto text-center text-gray-800"> {{ clientName }} </span>

                <div class="flex justify-around flex-wrap w-full my-2">
                  <span class="w-full text-xl text-blue-500 text-center my-0 py-0 ">Olá, <span
                      class="text-blue-800 font-bold w-full my-0 py-0" v-if="getUsuario">{{ getUsuario.nome  }}</span></span>
                  <span class="w-full text-xl text-blue-500 text-center my-0 py-0"><span
                      class="text-gray-900 text-sm font-light w-full my-0 py-0" v-if="getUsuario">{{ getUsuario.email }}</span></span>
                  <div class="flex flex-row justify-around w-full">
                    <button class=" justify-around bg-red-500 hover:bg-red-600 m-2 rounded px-4 py-2 inline-flex"
                      type="button" @click="logout">
                      <span class="text-center text-gray-50">
                        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                          <path fill="currentColor"
                            d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z" />
                        </svg>
                      </span>
                      <span>Sair</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <span class="flex flex-wrap gap-4 justify-around w-full p-8" v-if="getUsuario">
              <span class="" v-for="moduloPermitido in getUsuario.modulos">
                <span class="" v-for="modulo in modules">
                  <CardModules class="w-full" v-if="moduloPermitido === modulo.menu.title" :perfis="getUsuario.modulos"
                               :title="modulo.menu.title" :modulo="modulo" :subtitle="modulo.subtitle"
                               :namePath="modulo.menu.namePath" :menu="modulo.menu" />
                </span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
    <ModalLoading v-if="getLoading" />
  </div>
</template>

<script>
import modulos from "../mock/modulos";
import CardModules from '../components/layout/cardModules'
import Alerta from "@/components/base/Alerta.vue";
import Footer from "@/components/layout/Footer.vue";
import Header from "@/components/layout/Header.vue";
import ModalLoading from "@/components/base/ModalLoading.vue";
import {kc} from "@/security-keycloak";

export default {

  name: 'modulos',

  components: {
    ModalLoading,
    Footer,
    Header,
    Alerta,
    CardModules
  },

  data() {
    return {
      modules: modulos,
      listaModulos: undefined,
      usuario: undefined,
      ambiente: process.env.NODE_ENV,
      mensagemDeErro: undefined,
      mostrarAlerta: undefined,
      projectName: '',
      clientName: '',
      user: {
        username: null,
        firstName: null,
        lastName: null,
        email: null,
      }
    }
  },

  created(){
  },

  mounted() {
    this.projectName = process.env.VUE_APP_PROJETO;
    this.clientName = process.env.VUE_APP_CLIENT;
  },

  computed: {

    getLoading() {
      return this.$store.getters["getLoading"];
    },

    getUsuario() {
      return this.$store.getters["gateway/getUsuarioLogadoNoSistema"]
    },
  },
  methods: {
    fecharAlerta(){
      this.mensagemDeErro = undefined;
      this.mostrarAlerta = false;
    },
    async logout() {
      await kc.logout();
    },


  }

}
</script>

<style scoped>
html,
body {
  width: 100%;
  height: 100%;
}
</style>
